import { createContext } from "react";

export const HomeyApiContext = createContext({
  homeyApi: null,
  setHomeyApi: () => {},
});